export class ArrayHelper {
	public static firstOrDefault<T>(array: T[]): T | null {
		return array.length > 0 ? array[0] : null;
	}
}